import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { EcommerceCategoriaService } from '../services/EcommerceCategoriaService';

const CategoryMegaMenu = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const idEmpresa = 1;

    // Cargar categorías del backend
    useEffect(() => {
        const loadCategories = async () => {
            try {
                const response = await EcommerceCategoriaService.obtenerCategorias(idEmpresa);
                setCategories(response || []);
            } catch (error) {
                setCategories([]);
            } finally {
                setLoading(false);
            }
        };

        loadCategories();
    }, []);

    const isActiveCategory = (slug) => {
        const params = new URLSearchParams(location.search);
        return params.get('cat') === slug;
    };

    const handleCategoryClick = (catId) => {
        navigate(`/tienda/catalogo?cat=${catId}`);
    };

    return (
        <div className="ec-megamenu">
            {/* Botón "Todas" */}
            <Button
                label="Todas"
                icon="pi pi-th-large"
                className={`ec-megamenu-btn ${!new URLSearchParams(location.search).get('cat') && location.pathname === '/tienda/catalogo' ? 'active' : ''}`}
                onClick={() => navigate('/tienda/catalogo')}
            />

            {/* Botones con mega-menú para cada categoría */}
            {!loading && categories && categories.length > 0 ? (
                categories.map(cat => {
                    const catLabel = cat.nombre || cat.name || cat.descripcion || `Cat ${cat.id}`;
                    return (
                        <div
                            key={cat.id}
                            className="ec-megamenu-trigger"
                            title={catLabel}
                        >
                            <Button
                                label={catLabel}
                                icon={cat.icono || cat.icon || 'pi pi-th-large'}
                                iconPos="left"
                                className={`ec-megamenu-btn ${isActiveCategory(cat.id?.toString()) ? 'active' : ''}`}
                                onClick={() => handleCategoryClick(cat.id)}
                            />
                        </div>
                    );
                })
            ) : (
                <div style={{ color: '#999', padding: '10px' }}>
                    {loading ? 'Cargando categorías...' : 'Sin categorías'}
                </div>
            )}
        </div>
    );
};

export default CategoryMegaMenu;
